import { render } from "./PriceTypeList.vue?vue&type=template&id=f338345e&scoped=true"
import script from "./PriceTypeList.vue?vue&type=script&lang=js"
export * from "./PriceTypeList.vue?vue&type=script&lang=js"

import "./PriceTypeList.vue?vue&type=style&index=0&id=f338345e&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f338345e"]])

export default __exports__